namespace TabAurous.Common {
    export interface ExcelImportResponse extends Serenity.ServiceResponse {
        Inserted?: number;
        Updated?: number;
        ErrorList?: string[];
        Issues?: Issue[];
    }
}
